<template>
  <v-card outlined class="elevation-0">
    <v-card-text class="pa-5">
      <div class="d-flex align-items-center mb-4">
        <div>
          <h3 class="title font-weight-regular">User Stats</h3>
          <h6 class="subtitle-2 font-weight-light">
            Spent Time by user
          </h6>
        </div>
        <download-csv :data="items" class="ml-auto">
          <v-btn small class="ml-auto" color="channel" dark>Download CSV</v-btn>
        </download-csv>
      </div>
      <div
        v-if="isLoading"
        class="d-flex justify-center align-center"
        style="height:300px"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="!isLoading">
        <v-virtual-scroll
          height="300"
          :items="items"
          item-height="56"
          class="basic-scroll"
        >
          <template v-slot:default="{ item, index }">
            <v-list-item :key="item.name" class="pl-0">
              <v-chip
                label
                small
                class="ma-2"
                color="indigo"
                text-color="white"
              >
                {{ index + 1 }}
              </v-chip>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.id }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ showTime(item.minute) }}
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "UserStats",
  props: ["usersData"],
  data: () => ({
    isLoading: false,
    title: "User Stats",
    items: []
  }),
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    showTime(min) {
      const hrStr = min < 60 ? 0 : parseInt(min / 60);
      const minStr = min % 60;
      if (hrStr == 0) {
        return `${minStr}min`;
      } else {
        if (minStr == 0) {
          return `${hrStr}hr`;
        } else {
          return `${hrStr}hr ${minStr}min`;
        }
      }
    }
  },
  watch: {
    usersData: async function(newVal) {
      this.isLoading = true;
      this.items = [];
      for (const key in newVal) {
        const obj = {};
        obj.id = key;
        obj.minute = newVal[key];
        this.items.push(obj);
      }
      this.items.sort((a, b) => (a.name > b.name ? 1 : -1));

      this.isLoading = false;
    }
  },
  async mounted() {
    this.isLoading = true;
    let iter = 0;
    while (!this.usersData) {
      iter++;
      await this.sleep(100);
      if (iter > 100) break;
    }

    this.items = [];
    for (const key in this.usersData) {
      const obj = {};
      obj.id = key;
      obj.minute = this.usersData[key];
      this.items.push(obj);
    }
    this.items.sort((a, b) => (a.name > b.name ? 1 : -1));

    console.log("items", this.items, this.usersData);
    this.isLoading = false;
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  .top-margin {
    margin-top: 30px;
  }
}
</style>
<style scoped>
.basic-scroll::-webkit-scrollbar {
  width: 12px;
  background: #ffffff;
}
.basic-scroll::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: #ced4da;
  background-clip: padding-box;
  border: 3px solid transparent;
}
.basic-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #adb5bd;
}
.basic-scroll::-webkit-scrollbar-track {
  background: #ffffff;
}
</style>
